// extracted by mini-css-extract-plugin
module.exports = {"drawer":"Footer_drawer__hscHc","wrapper":"Footer_wrapper__UQfu_","logo":"Footer_logo__nQIYM"};